import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Divider from '@material-ui/core/Divider'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Switch from '@material-ui/core/Switch'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FolderIcon from '@material-ui/icons/Folder'
import DeleteIcon from '@material-ui/icons/Delete'
import SearchIcon from '@material-ui/icons/Search'

const styles = (theme) => {
  return {
    content: {
      backgroundColor: 'white',
      borderRadius: '5px',
      boxShadow: '0 0 5px #D2D2D2',
    },
    contentTitle: {
      fontSize: '12px',
      padding: '1% 2% 1% 2%',
    },
    formContainer: {
      padding: '2%',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      '& fieldset': {
        top: '-5px',
        borderRadius: '4px',
        borderWidth: '1px',
      },
      '& input': {
        padding: '14px 14px',
        fontSize: '12px',
      },
    },
    textField: {
      marginLeft: `${theme.spacing.unit}px`,
      marginRight: `${theme.spacing.unit}px`,
      marginTop: `${theme.spacing.unit * 2}px`,
      marginBottom: `${theme.spacing.unit}px`,
    },
    dividerHeight: {
      height: '1px',
    },
    switches: {
      width: '62px',
    },
    switchesBase: {
      width: '48px',
      height: '48px',
    },
    switchesIconChecked: {
      width: '20px',
      height: '20px',
    },
    switchesIcon: {
      width: '20px',
      height: '20px',
    },
    switchesBar: {
      width: '34px',
      height: '14px',
      marginTop: '-7px',
      marginLeft: '-17px',
      borderRadius: '7px',
    },
    formGroupSwitchText: {
      paddingLeft: '14px',
      fontSize: '12px',
    },
    menu: {
      width: '200px',
    },
    menuItem: {
      padding: '4px 16px 4px 16px',
    },
    selectIcon: {
      '& svg': {
        fontSize: '24px',
        position: 'absolute',
        right: '10px',
      },
    },
    inputAdornmentEnd: {
      display: 'inline-flex',
      right: '15px',
      position: 'absolute',
      alignItems: 'center',
      color: 'cornflowerblue',
    },
    inputAdornmentEndIcon: {
      fontSize: '20px',
    },
    inputAdornmentEndText: {
      fontSize: '10px',
      paddingLeft: '4px',
    },
    card: {
      maxWidth: '345px',
      margin: '10px',
      borderRadius: '4px',
    },
    cardContent: {
      padding: '16px',
    },
    cardActionButton: {
      flex: '1',
      fontSize: '10px',
    },
    media: {
      height: '200px',
    },
  }
}

const classIds = [
  {
    value: '3A',
    label: '3A',
  },
  {
    value: '3B',
    label: '3B',
  },
  {
    value: '3C',
    label: '3C',
  },
  {
    value: '3D',
    label: '3D',
  },
]

class Form extends React.Component {
  state = {
    checked: [false, false, false, false, false, false, false, false],
    classId: '3A',
  }

  handleBrowse = () => {}

  handleChange = (name) => {
    return (event) => {
      this.setState({
        [name]: event.target.value,
      })
    }
  }

  handleClick = (index) => {
    const checkedCopy = JSON.parse(JSON.stringify(this.state.checked))
    checkedCopy[index] = !checkedCopy[index]
    console.log(checkedCopy)
    this.setState(() => {
      return { checked: checkedCopy }
    })
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.content}>
        <div className={classes.contentTitle}>EDIT STUDENT</div>
        <Divider className={classes.dividerHeight} />
        <div className={classes.formContainer}>
          <form className={classes.container} noValidate autoComplete="off">
            <TextField
              id="outlined-full-width"
              label="Student Number"
              style={{ margin: 8 }}
              placeholder="Edit Student Number"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="outlined-full-width"
              label="Student Chinese Name"
              style={{ margin: 8 }}
              placeholder="Edit Student Chinese Name"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="outlined-full-width"
              label="Student English Name"
              style={{ margin: 8 }}
              placeholder="Edit Student English Name"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="outlined-full-width"
              label="Class Number"
              style={{ margin: 8 }}
              placeholder="Edit Class Number"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="outlined-select-currency"
              select
              label="Class"
              style={{ margin: 8 }}
              fullWidth
              margin="normal"
              variant="outlined"
              className={classes.textField}
              classes={{ root: classes.selectIcon }}
              value={this.state.classId}
              onChange={this.handleChange('classId')}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
            >
              {classIds.map((option) => {
                return (
                <MenuItem key={option.value} value={option.value} className={classes.menuItem}>
                  {option.label}
                </MenuItem>
                )
              })}
            </TextField>
            <Card className={classes.card}>
              <CardActionArea>
                <CardMedia
                  className={classes.media}
                  image="url(https://oralcancerfoundation.org/wp-content/uploads/2016/03/people.jpg)"
                  title="Profile Picture"
                />
                <CardContent>
                  <Typography gutterBottom className={classes.cardContent}>
                    fileName(eg. 123414.JPG)
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button color="primary" className={classes.cardActionButton}>
                  <DeleteIcon />
                  Remove
                </Button>
                <Button color="primary" className={classes.cardActionButton}>
                  <SearchIcon />
                  Preview
                </Button>
              </CardActions>
            </Card>
            <TextField
              id="outlined-full-width"
              label="Photo"
              style={{ margin: 8 }}
              placeholder="Select files..."
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <div className={classes.inputAdornmentEnd}>
                    <FolderIcon className={classes.inputAdornmentEndIcon} />
                    <span className={classes.inputAdornmentEndText}>Browse</span>
                  </div>
                ),
              }}
            />
            <TextField
              id="outlined-full-width"
              label="Reset Password"
              style={{ margin: 8 }}
              placeholder="Enter New Password"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="outlined-full-width"
              label="Balance"
              style={{ margin: 8 }}
              placeholder="HKD 0.00"
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            {/* <Divider className={classes.dividerHeight}/> */}
            {/* <div> */}
            {/* <CancelIcon/>Cancel <SaveIcon/>Save */}
            {/* </div> */}
          </form>
          <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.formGroupSwitchText}>
              Authority
            </FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[0]}
                    onClick={() => {
                      return this.handleClick(0)
                    }}
                    value="0"
                  />
                }
                label="Access 1"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[1]}
                    onClick={() => {
                      return this.handleClick(1)
                    }}
                    value="1"
                  />
                }
                label="Access 2"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[2]}
                    onClick={() => {
                      return this.handleClick(2)
                    }}
                    value="2"
                  />
                }
                label="Access 3"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[3]}
                    onClick={() => {
                      return this.handleClick(3)
                    }}
                    value="3"
                  />
                }
                label="Access 4"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[4]}
                    onClick={() => {
                      return this.handleClick(4)
                    }}
                    value="4"
                  />
                }
                label="Access 5"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[5]}
                    onClick={() => {
                      return this.handleClick(5)
                    }}
                    value="5"
                  />
                }
                label="Access 6"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[6]}
                    onClick={() => {
                      return this.handleClick(6)
                    }}
                    value="6"
                  />
                }
                label="Access 7"
              />
              <FormControlLabel
                control={
                  <Switch
                    className={classes.switches}
                    classes={{
                      switchBase: classes.switchesBase,
                      iconChecked: classes.switchesIconChecked,
                      icon: classes.switchesIcon,
                      bar: classes.switchesBar,
                    }}
                    checked={this.state.checked[7]}
                    onClick={() => {
                      return this.handleClick(7)
                    }}
                    value="7"
                  />
                }
                label="Access 8"
              />
            </FormGroup>
          </FormControl>
        </div>
      </div>
    )
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Form)
